import React, { useState } from 'react';
import { Modal, Select, Button, Flex, Dropdown } from 'antd';
import { UserOutlined, FileOutlined, FileTextOutlined } from '@ant-design/icons';
import styles from './user-analytics-modal.module.scss';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

export const UserAnalyticsModal = ({ visible, onClose }) => {
  const [timeRange, setTimeRange] = useState('7days');
  const [selectedUser, setSelectedUser] = useState('john');

  const timeRangeOptions = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '90days', label: 'Last 90 Days' },
    { value: 'year', label: 'Last Year' },
  ];

  const userOptions = [
    { value: 'john', label: 'John Smith' },
    { value: 'jane', label: 'Jane Doe' },
    { value: 'bob', label: 'Bob Johnson' },
    { value: 'all', label: 'All Users' },
  ];
  const chartData = [
    { name: 'Leads Handled', value: 145 },
    { name: 'Leads Matched', value: 100 },
  ];

  const handleExportCSV = () => {
    // In a real implementation, this would export the analytics data as CSV
    console.log('Exporting analytics data as CSV');

    // Example implementation (in a real app, you would use a proper CSV library)
    const headers = ['Metric', 'Value'];
    const csvData = [
      ['Leads Handled', '145'],
      ['Success Rate', '67.6%'],
      ['Active Time', '87h'],
      ['Queue Activity', '92.0%'],
    ];

    const csvContent = [headers.join(','), ...csvData.map((row) => row.join(','))].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `user_analytics_${selectedUser}_${timeRange}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPDF = () => {
    // In a real implementation, this would export the analytics data as PDF
    console.log('Exporting analytics data as PDF');
    // This would typically use a PDF generation library like jsPDF
    alert('PDF export functionality would be implemented here with a PDF library');
  };

  return (
    <Modal
      title={
        <div>
          <div className={styles.modalTitle}>User Analytics</div>
          <div className={styles.modalSubtitle}>View team performance metrics and analytics</div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      width={1000}
      footer={null}>
      <div>
        <Flex className="spacing-mb-24" gap={16} alignItems="center">
          <div className={styles.modalTitle}>User Analytics</div>
          <div className={styles.spacer} />
          <Select
            className={styles.filterSelect}
            value={timeRange}
            onChange={setTimeRange}
            options={timeRangeOptions}
            suffixIcon={<span className="text-dark-blue-50">▼</span>}
          />

          <Select
            className={styles.filterSelect}
            value={selectedUser}
            onChange={setSelectedUser}
            options={userOptions}
            suffixIcon={<span className="text-dark-blue-50">▼</span>}
          />

          <Button className={styles.teamViewButton}>
            <UserOutlined style={{ marginRight: '4px' }} />
            Team View
          </Button>

          <Dropdown
            menu={{
              items: [
                {
                  key: 'csv',
                  label: 'Export as CSV',
                  onClick: handleExportCSV,
                },
                {
                  key: 'pdf',
                  label: 'Export as PDF',
                  onClick: handleExportPDF,
                },
              ],
            }}
            placement="bottomRight"
            trigger={['click']}
            overlayClassName={styles.exportDropdown}>
            <Button className={styles.exportButton}>
              <FileOutlined />
            </Button>
          </Dropdown>
        </Flex>

        <div className={styles.metricsContainer}>
          <div className={styles.metricCard}>
            <div className={styles.metricTitle}>Leads Handled</div>
            <div className={styles.metricValue}>145</div>
            <div className={styles.metricDescription}>Total leads processed</div>
          </div>

          <div className={styles.metricCard}>
            <div className={styles.metricTitle}>Success Rate</div>
            <div className={styles.metricValue}>67.6%</div>
            <div className={styles.metricDescription}>Lead to match conversion</div>
          </div>

          <div className={styles.metricCard}>
            <div className={styles.metricTitle}>Active Time</div>
            <div className={styles.metricValue}>87h</div>
            <div className={styles.metricDescription}>Hours active this month</div>
          </div>

          <div className={styles.metricCard}>
            <div className={styles.metricTitle}>Queue Activity</div>
            <div className={styles.metricValue}>92.0%</div>
            <div className={styles.metricDescription}>Queue participation rate</div>
          </div>
        </div>

        <div className={styles.chartSection}>
          <div className={styles.chartTitle}>Lead Performance</div>
          <div className={styles.chartSubtitle}>Individual lead handling metrics</div>

          <div style={{ width: '100%', height: 250 }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }} barSize={298}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#00506C" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </Modal>
  );
};
